'use client'

import { RefreshRouteOnSave as PayloadLivePreview } from '@payloadcms/live-preview-react'
import { useRouter } from 'next/navigation'
import React from 'react'

export const RefreshRouteOnSave: React.FC = () => {
  const router = useRouter()

  // Must match the admin's origin, which on preview deployments isn't production.
  const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
  const serverURL = isPreview
    ? typeof window !== 'undefined'
      ? window.location.origin
      : process.env.NEXT_PUBLIC_VERCEL_URL
        ? `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
        : undefined
    : process.env.NEXT_PUBLIC_SERVER_URL

  // Don't render live preview component if serverURL is not configured
  // This prevents postMessage errors in production when the env var is missing
  if (!serverURL) {
    return null
  }

  return <PayloadLivePreview refresh={() => router.refresh()} serverURL={serverURL} />
}
